import { useParams } from "react-router-dom";
import { Container } from "@/components/atoms";
import { CompaniesViewPanel, PageHeader, PageHeaderV2 } from "@/components/organisms";
import { Restricted } from "..";

export const CompaniesView = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) return <Restricted />;

  return (
    <Container className="mb-12 flex w-full flex-1 flex-col">
      <PageHeaderV2 name="Companies" skipCrumbs={1} />
      <PageHeader.Actions />
      <CompaniesViewPanel companyId={id} />
    </Container>
  );
};
